import { Box } from '@mui/material';
import { Helmet } from 'react-helmet';

import { AppIcon } from '@/modules/common/components/icons';

export interface Props {
  title: string;
  children: React.ReactNode;
}

const AuthLayout = ({ title, children }: Props) => {
  return (
    <Box
      component="div"
      sx={{
        display: 'flex',
        height: '100vh',
        minHeight: '100%',
        backgroundColor: 'transparent',
      }}
    >
      <Helmet>
        <title>{title} - mavue</title>
      </Helmet>
      <Box
        component="div"
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: '1',
          justifyContent: 'center',
          alignItems: 'center',
          width: '60%',
          zIndex: 1,
        }}
      >
        <AppIcon className="h-14 w-14 shrink-0" />
        {children}
      </Box>
    </Box>
  );
};

export default AuthLayout;
